
import { CellRender } from "../../types"
import {TreeSelectCell} from "./TreeSelectCell"
import { TreeCellNode } from "./types"

export function renderTreeSelectCell(rootNodes: TreeCellNode[]): CellRender {
  return params => {
    return <TreeSelectCell cellParams={params} rootNodes={rootNodes} />
  }
}
